import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { BsSpeedometer2 } from "react-icons/bs";
import { useSelector } from "react-redux";

export const UserMeter = ({ userProfile }) => {
  const pageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor
  );

  const utilityType = useSelector(
    (state) => state?.switchTab?.currentDisplay?.utilityType
  );

  const activeAccount = useSelector((state) => state?.account?.activeAccount);

  const meterNumber =
    activeAccount?.meterNumbers?.[utilityType] ||
    activeAccount?.meterNumbers?.water;

  // Meter numbers are estate/admin-controlled — residents never edit this
  // field, only see its current state.
  let statusMessage = null;
  if (!activeAccount?.estateId) {
    statusMessage =
      "Meter information becomes available when you join or select an estate.";
  } else if (!meterNumber) {
    statusMessage =
      "No meter has been assigned yet. Please contact your estate administrator.";
  }

  return (
    <Box bg="#fff" p="30px" borderRadius={"10px"} shadow="md">
      <Flex justifyContent="space-between">
        <Box>
          <Text fontWeight="medium">My Meter</Text>
          <Box>
            <Text color="#c4c4c4" fontSize="14px" mt="14px">
              Meter Number
            </Text>
            {statusMessage ? (
              <Text color="gray.500" fontSize="14px" maxW="260px" mb="5px">
                {statusMessage}
              </Text>
            ) : (
              <>
                <Text fontWeight="bold" mb="5px" fontSize={["28px"]}>
                  {meterNumber}
                </Text>
                <Text
                  p="5px"
                  border={`${pageColor} 2px solid`}
                  borderRadius="25px"
                  textAlign="center"
                  bg="#f9feff"
                >
                  Prepaid
                </Text>
              </>
            )}
          </Box>
        </Box>
        <Box>
          <BsSpeedometer2 color={pageColor} size={50} />
        </Box>
      </Flex>
    </Box>
  );
};
